import { Modal, Button } from "react-bootstrap";


const CustomModal = ({
  children,
  show,
  handleClose = () => { },
  headerText = null,
  closeButtonText = null,
  actionButtonText = null,
  actionButton = () => { },
  actionButtonDisable = false
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      backdrop={true}
      dialogClassName="modal-dialog-scrollable"
    >
      {headerText && (
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 style={{ fontWeight: 600 }} className="m-0">{headerText}</h4>
          </Modal.Title>
        </Modal.Header>
      )}

      <Modal.Body className="text-center">
        {children}
      </Modal.Body>

      {(closeButtonText || actionButtonText) && (
        <Modal.Footer>
         
          {closeButtonText && (
            <Button variant="outline-dark" onClick={handleClose}>
              {closeButtonText}
            </Button>
          )}
           {actionButtonText && (
            <Button disabled={actionButtonDisable} variant="dark" onClick={actionButton}>
              {actionButtonText}
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
};
export default CustomModal;
